import { isDevEnv } from '@/config';
import { wait } from '@/utils/fns';
import { getGlobal } from '@/utils/global';
import { BarcodeEvent } from '@/utils/KeyInput/Barcode';
import { log } from '@/utils/log';

export function devPatch() {
  if (!isDevEnv && localStorage.getItem('enable_dev_console') !== 'true') {
    return;
  }

  // @ts-ignore
  window.dev = devObject;
}

declare global {
  // eslint-disable-next-line no-var
  let dev: typeof devObject;
}

function simulateBarcodeScan(code: string) {
  log.debug('[dev] simulating barcode scan [%o]', code);
  const barcodeInput = getGlobal('barcodeInput');
  barcodeInput.dispatchEvent(new BarcodeEvent(code));
}

/**
 *
 * @param keys either a string of digit keys to simulate or an array of keys to simulate
 * @example
 */
async function simulateNumpadKeys(keys: string | string[]) {
  log.debug('[dev] simulating numpad keys [%o]', keys);
  const isDigit = (key: string) => /^\d+$/.test(key);

  if (Array.isArray(keys)) {
    for (const key of keys) {
      const code = isDigit(key) ? `Numpad${key}` : key;
      simulateNumpad(code);
      await wait(100);
    }
    return;
  }

  for (const key of keys.split('')) {
    if (!isDigit(key)) {
      // eslint-disable-next-line no-continue
      continue;
    }

    simulateNumpad(`Numpad${key}`);
    await wait(100);
  }

  await wait(200);
  simulateNumpad('NumpadEnter');
}

function simulateNumpad(code: string) {
  window.dispatchEvent(new KeyboardEvent('keydown', { code }));
}

const devObject = {
  showMenu: () => {
    simulateNumpadKeys(['9', 'Backspace']);
  },
  numpad: {
    simulate: simulateNumpad,
    simulateKeys: simulateNumpadKeys,
    enter: () => simulateNumpad('NumpadEnter'),
    backspace: () => simulateNumpad('Backspace'),
  },
  barcodes: {
    simulateBarcodeScan,
    scan: {
      accessCardBoxLotNumber: () => simulateBarcodeScan('ln:7QQZL2MD'),
      mifareClassicCardLotNumber: () => simulateBarcodeScan('ln:XJD7ZRG3'),
      mifareClassicCardSerialNumber: () => simulateBarcodeScan('sn:HJD7ZJLR'),
      noaId: (id = '9JD5NJKH') =>
        simulateBarcodeScan(`https://persidius.link/c/${id.toUpperCase()}`),
      noaId2: (id = '2DZ8GUOM') =>
        simulateBarcodeScan(`https://persidius.link/c/${id.toUpperCase()}`),
    },
  },
};
